module.exports = __webpack_public_path__ + "static/img/box1.a687697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/box1.png
// module id = u9hM
// module chunks = 0